<template>
  <v-card :loading="form.processing" flat>
    <v-card-title>
      <slot name="header"></slot>
    </v-card-title>
    <v-card-text>
      <v-form ref="form" class="mt-4" :disabled="isReadonly || form.processing">
        <div class="label mb-2">Lesson Plan</div>
        <v-autocomplete
          v-model="form.lesson_plan_id"
          :items="lessonPlans"
          :rules="[validationRules.required]"
          :error="form.errors && form.errors.lesson_plan_id"
          :error-messages="form.errors.lesson_plan_id"
          :loading="isLessonPlanListLoading"
          item-text="name"
          item-value="id"
          solo
          flat
          outlined
          dense
          placeholder="Choose lesson plan"
          @change="changeLessonPlan"
        />
        <v-row>
          <v-col md="6" cols="12">
            <div class="label mb-2">Class Type</div>
            <v-select
              v-model="form.classroom_type"
              :items="classroomTypeOptions"
              :rules="[validationRules.required]"
              :error="form.errors && form.errors.classroom_type"
              :error-messages="form.errors.classroom_type"
              solo
              flat
              outlined
              dense
              placeholder="Choose class type"
            />
          </v-col>
          <v-col md="3" cols="12">
            <div class="label mb-2">Jumlah Pertemuan</div>
            <v-text-field
              v-model="form.class_per_week"
              :rules="[validationRules.required]"
              :error="form.errors.class_per_week"
              :error-messages="form.errors.class_per_week"
              type="number"
              suffix="X per minggu"
              solo
              flat
              outlined
              dense
              placeholder="Jumlah kelas"
            />
          </v-col>
          <v-col md="3" cols="12">
            <div class="label mb-2">Waktu Belajar</div>
            <v-text-field
              v-model="form.minutes_per_class"
              :rules="[validationRules.required]"
              :error="form.errors.minutes_per_class"
              :error-messages="form.errors.minutes_per_class"
              type="number"
              suffix="menit per pertemuan"
              solo
              flat
              outlined
              dense
              placeholder="Waktu belajar"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col md="6" cols="12">
            <div class="label mb-2">Package Name</div>
            <v-text-field
              v-model="form.name"
              :rules="[validationRules.required]"
              :error="form.errors.name"
              :error-messages="form.errors.name"
              solo
              flat
              outlined
              dense
              placeholder="Subcsription package name"
            />
          </v-col>
          <v-col md="6" cols="12">
            <div class="label mb-2">Package Name (Chinese)</div>
            <v-text-field
              v-model="form.name_cn"
              :error="form.errors.name_cn"
              :error-messages="form.errors.name_cn"
              solo
              flat
              outlined
              dense
              placeholder="Subcsription package name"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col md="6" cols="12">
            <div class="label mb-2">Package Description</div>
            <v-textarea
              v-model="form.description"
              solo
              flat
              outlined
              dense
              auto-grow
              placeholder="Package description"
            />
          </v-col>
          <v-col md="6" cols="12">
            <div class="label mb-2">Package Description (Chinese)</div>
            <v-textarea
              v-model="form.description_cn"
              solo
              flat
              outlined
              dense
              auto-grow
              placeholder="Package description"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col md="6" cols="12">
            <div class="label mb-2">Monthly Fee</div>
            <v-text-field
              v-model="monthlyFee"
              :rules="[validationRules.required]"
              :error="form.errors.monthly_fee"
              :error-messages="form.errors.monthly_fee"
              prefix="IDR"
              suffix="per month"
              class="input-right"
              solo
              flat
              outlined
              dense
              placeholder="Montlhly Fee"
            />
          </v-col>
          <v-col md="6" cols="12">
            <div class="label mb-2">Deposit Amount</div>
            <v-text-field
              v-model="depositAmount"
              :error="form.errors.deposit_amount"
              :error-messages="form.errors.deposit_amount"
              prefix="IDR"
              class="input-right"
              solo
              flat
              outlined
              dense
              placeholder="Deposit Amount"
            />
          </v-col>
        </v-row>
        <div class="label mb-2">Status</div>
        <v-select
          v-model="form.status"
          :items="statusOptions"
          :rules="[validationRules.required]"
          :error="form.errors.status"
          :error-messages="form.errors.status"
          solo
          flat
          outlined
          dense
          placeholder="Select status"
        />
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-container fluid>
        <v-row justify="end">
          <v-col md="3" cols="12">
            <v-btn block depressed outlined @click="cancel">Cancel</v-btn>
          </v-col>
          <v-col md="3" cols="12">
            <v-btn
              block
              depressed
              color="primary"
              :disabled="isReadonly || form.processing"
              @click="submit"
            >
              Save Changes
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-card-actions>
  </v-card>
</template>
<script>
import constant from '@/constant'
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'SubcriptionPackageForm',
  props: {
    mode: {
      type: String,
      required: true,
      validator: () => ['add', 'edit', 'view'],
    },
    subscriptionPackage: {
      type: Object,
      default: null,
      required: false,
    },
  },
  data() {
    return {
      form: this.$inertia.form({
        class_per_week: null,
        minutes_per_class: null,
        name: null,
        name_cn: null,
        description: null,
        description_cn: null,
        lesson_plan_id: null,
        image_url: null,
        classroom_type: null,
        monthly_fee: 0,
        deposit_amount: 0,
        status: null,
      }),
    }
  },
  computed: {
    ...mapGetters({
      lessonPlanList: 'lessonPlan/list',
      isLessonPlanListLoading: 'lessonPlan/isListLoading',
    }),
    isReadonly() {
      return this.mode === 'view'
    },
    statusOptions() {
      return constant.subscriptionPackageStatusOptions
    },
    lessonPlans() {
      return this.lessonPlanList.data
    },
    selectedLessonPlan() {
      return this.form.lesson_plan_id
        ? this.lessonPlans.find((e) => e.id === this.form.lesson_plan_id)
        : null
    },
    classroomTypeOptions() {
      return constant.classroomTypeOptions
    },
    monthlyFee: {
      get() {
        return this.formatNumber(this.form.monthly_fee)
      },
      set(value) {
        this.form.monthly_fee = this.parseNumber(value)
      },
    },
    depositAmount: {
      get() {
        return this.formatNumber(this.form.deposit_amount)
      },
      set(value) {
        this.form.deposit_amount = this.parseNumber(value)
      },
    },
  },
  watch: {
    $props: {
      immediate: true,
      handler() {
        this.validateProps()
      },
    },
  },
  created() {
    this.init()
  },
  methods: {
    ...mapActions({
      upload: 'storage/upload',
      getLessonPlanList: 'lessonPlan/getList',
    }),
    validateProps() {
      if (
        (this.mode === 'edit' || this.mode === 'view') &&
        !this.subscriptionPackage
      ) {
        console.error(
          `subscription package props must be provided for 'edit' and 'view' mode`
        )
      }
    },
    init() {
      if (this.mode != 'add' && this.subscriptionPackage != null) {
        _.merge(this.form, this.subscriptionPackage)
      }
      this.getLessonPlanList({
        status: 'ACTIVE',
      })
    },
    async uploadFile({ file, prop }) {
      const responseData = await this.upload({
        file,
        baseDir: 'subscription-package',
      })
      if (responseData) {
        this.form[prop] = responseData.url
      }
    },
    changeLessonPlan() {
      this.form.class_per_week = this.selectedLessonPlan.class_per_week
      this.form.minutes_per_class = this.selectedLessonPlan.minutes_per_class
    },
    cancel() {
      this.$emit('cancel')
    },
    async submit() {
      if (this.$refs.form.validate()) {
        if (this.mode === 'add') {
          this.form.post('/subscription-packages')
        } else if (this.mode === 'edit') {
          this.form.put(`/subscription-packages/${this.subscriptionPackage.id}`)
        }
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.input-right {
  :deep(input) {
    text-align: right;
  }
}
</style>
